(function () {
  var VAT = 1.23; // zmień jeśli stawka VAT jest inna

  function formatPLN(value) {
    return value.toFixed(2).replace('.', ',') + ' zł netto';
  }

  function injectNettoColumn(table) {
    // Nagłówek
    var thead = table.querySelector('thead tr');
    if (thead) {
      var th = document.createElement('th');
      th.className = 'ymq-b2b-table-th ymq-b2b-table-item';
      th.textContent = 'Cena netto';
      thead.appendChild(th);
    }

    // Wiersze
    var rows = table.querySelectorAll('tbody tr');
    rows.forEach(function (row) {
      var priceSpan = row.querySelector('[data-ymq-money]');
      if (!priceSpan) return;

      var gross = parseFloat(priceSpan.getAttribute('data-ymq-money'));
      var net = gross / VAT;

      var td = document.createElement('td');
      td.className = 'ymq-b2b-table-td ymq-b2b-table-item';
      td.textContent = formatPLN(net);
      row.appendChild(td);
    });

    table.setAttribute('data-netto-injected', '1');
  }

  function tryInject() {
    document.querySelectorAll('.ymq-b2b-qb-table:not([data-netto-injected])').forEach(injectNettoColumn);
  }

  // Próbuj od razu i obserwuj DOM na wypadek lazy-load tabeli przez YMQ
  tryInject();

  var observer = new MutationObserver(tryInject);
  observer.observe(document.body, { childList: true, subtree: true });
})();

